export function initials(name) {
    return name ? name.charAt(0).toUpperCase() : "A";
}
